/**
 * 模块接口
 */
import { get, post } from '@http/request'
import qs from 'qs'

/**
 * 工作台
 */
export const reqTodayCount = (params) => get(`vip/data/today/count`, params)
export const reqTotalCount = (params) => get(`vip/data/total/count`, params)

/**
* 用户管理
*/
// 新增用户
export const addNewUser = (params) => post(`/vip/user/save`, params)
// 用户详情
export const UserDetail = (params) => get(`/vip/user/detail`, params)
// 获取子账号
export const findChildAccount = (params) => get(`/vip/user/findChildAccount`, params)

// 修改用户 /  切换用户状态
export const UserUpdate = (params) => post(`/vip/user/update`, params)
// 删除用户
export const UserDelete = (params) => post(`/vip/user/delete`, qs.stringify(params))

// 用户列表
export const reqUserList = (params) => get(`/vip/user/page`, params)
// 更新收款邮箱
export const changeEmail = (params) => post(`/vip/user/changeEmail`, params)

// 地址列表
export const reqAddressList = (params) => get(`/vip/address/page`, params)
// 校验省市区是否开通
export const checkArea = (params) => post(`/vip/area/check`, qs.stringify(params), { 'content-type': 'application/x-www-form-urlencoded' })
// 新增地址
export const addAddress = (params) => post(`/vip/address/add`, params)
// 修改地址
export const updateAddress = (params) => post(`/vip/address/update`, params)
// 删除地址
export const delAddress = (params) => post(`/vip/address/delete`, params)
// 获取默认地址
export const getDefaultAddress = (params) => get(`/vip/address/getDefaultAddress`, params)
// 获取地址模板
export const downloadAddressTemplate = () => post(`/vip/address/downloadTemplate`, '', { responseType: 'blob' })

// 新下载模板 20201209新增
export const downloadTemplateNew = (params) => post(`/vip/excel/downloadTemplate`, params, { responseType: 'blob' })

// 物流信息-快件跟踪（单个）
export const getDetailByWaybillNo = (params) => get(`/vip/logisticsTracking/getDetailByWaybillNo`, params)

//  物流信息-快件跟踪（批量查询）
// export const getDetailByWaybillNos = (params) => get(`/vip/logisticsTracking/getDetailByWaybillNos`, params)
export const getDetailByWaybillNos = (reqData) => post(`/vip/logisticsTracking//v2/getDetailByWaybillNo`, reqData)

//  运费计算
// export const freightCalculation = (params) => post(`/vip/costCalculation/spmCustomerShippingQuote/comCost`, params)

//  通过省市区匹配结算目的地
export const getSettlement = (params) => post(`/vip/area/getSettlementDestinationByProvinceCityAreaId`, params)

// 单票下单：新增订单
export const vipOrderAdd = (reqData) => post(`/vip/order/add`, reqData)

// 单票下单：运费计算
export const getComCost = (reqData) => post(`/vip/costCalculation/spmCustomerShippingQuote/comCost`, reqData)

// 单票下单：保价费计算
export const getComputationCost = (reqData) => post(`/vip/costCalculation/insuranceFee/computationCost`, reqData)

// 单票下单：代收货款手续费计算
export const getCalc = (reqData) => post(`/vip/costCalculation/spmiCollectionfeeCustomerFee/calc`, reqData)

// 保价费计算（批量）
export const getcomCostBatch = (reqData) => post(`/vip/costCalculation/insuranceFee/comCostBatch`, reqData)

// 单票下单：综合拉取基础数据
export const getList = () => get(`/vip/baseData/list`)

// 单票下单：列表带分页
export const addressPage = (params) => get(`/vip/address/page`, params)

// 单票下单：新增地址
export const addressAdd = (reqData) => post(`/vip/address/add`, reqData)

// 运单：运单列表
export const waybillOrder = (params) => post(`/vip/waybillOrder/page`, params)

// 运单：运单状态数据统计
export const countByStatus = (params) => post(`/vip/waybillOrder/countByStatus`, params)

// 运单：运单导出
export const waybillExport = (reqData) => post(`/vip/waybillOrder/export`, reqData, { responseType: 'arraybuffer' })
// 运单：异步运单导出
export const asyExportWaybill = (reqData) => post(`/vip/waybillOrder/asyExport`, reqData)

// 运单：运单删除
export const waybillDelete = (reqData) => post(`/vip/waybillOrder/delete`, qs.stringify(reqData))

// 运单：运单详情
export const getDetailById = (params) => get(`/vip/waybillOrder/getDetailByNo`, params)

// 运单：根据运单号查询退件登记时间
export const getRebackExpress = (params) => get(`/vip/waybillOrder/getRebackExpress`, params)

// 订单：订单列表
export const orderList = (reqData) => post(`/vip/order/list`, reqData)

// 订单：订单列表-三方下单
export const orderListThridNo = (reqData) => post(`/vip/thridOrder/noOrderlist`, reqData)

// 订单：订单列表-三方下单-立即下单
export const batchSave = (reqData) => post(`/vip/thridOrder/batchSave`, reqData)

// 订单：订单列表-三方下单-取消订单
export const cancelById = (reqData) => post(`/vip/shopify/order/cancle`, reqData)
// export const cancelById = (reqData) => get(`/vip/thridOrder/cancelByIds`, reqData)

// 订单：订单列表-三方订单
export const orderListThrid = (reqData) => post(`/vip/thridOrder/getPages`, reqData)

// 订单：订单状态分组统计总数
export const orderTotalGroup = (reqData) => post(`/vip/order/totalGroup`, reqData)

// 订单：三方订单分组统计总数
export const orderTotalGroupThrid = (reqData) => post(`/vip/thridOrder/totalGroup`, reqData)

// 订单：三方下单分组统计总数
export const orderTotalGroupThridNo = (reqData) => post(`/vip/thridOrder/noOrderTotalGroup`, reqData)

// 订单：修改订单
export const orderUpdate = (reqData) => post(`/vip/order/update`, reqData)

// 订单：合并订单
export const orderMerge = (reqData) => post(`/vip/order/merger`, reqData)

// 订单：订单详情
export const detailOrder = (params) => get(`/vip/order/detailOrder`, params)

// 订单：订单导出
export const regularOutputExcel = (reqData) => post(`/vip/order/regularOutputExcel`, reqData, { responseType: 'arraybuffer' })
// 订单：订单异步导出
export const asyExportOrder = (reqData) => post(`/vip/order/asyExportOrder`, reqData)
// 订单：订单异步导出
export const asyExportOrderThrid = (reqData) => post(`/vip/thridOrder/asyExportOrder`, reqData)

// 订单：删除订单
export const orderrDelete = (reqData) => post(`/vip/order/delete?orderId=${reqData.orderId}`)

// 订单：订单子单打印
// export const printOrders = (params) => get(`/vip/order/printOrders`, params)
// export const printOrders = (reqData) => post(`/vip/order/newPrintOrders`, reqData, { responseType: 'blob' })
export const printOrders = (reqData) => post(`/vip/order/orderPrintUrl`, reqData)
// shpoify打印面单
export const printShopify = (reqData) => post(`/vip/shopify/orderPrintUrl`, reqData)

// 订单取消
export const orderCancel = (params) => post(`/vip/order/cancel`, params)

// 子订单查询
export const subOrderList = (params) => get(`/vip/order/subOrderList`, params)

// 子订单打印
export const printOrderSubs = (params) => get(`/vip/order/printOrderSubs`, params)

// 批量删除订单
export const orderBatchDelete = reqData => post(`/vip/order/batchDelete`, reqData)

/**
* 批量下单
*/
// 订单列表

// 下载模板
export const downloadTemplate = (typeTemplate) => post(`/vip/order/${typeTemplate}`, '', { responseType: 'blob' })
// 批量导入
export const excelImport = (params) => post(`/vip/order/excelImport`, params)
// 批量新增订单
export const batchAdd = (params) => post(`/vip/order/batchAdd`, params)
// 批量取消订单
export const cancel = (params) => post(`/vip/order/cancel`, params)
// 客户订单号验重
export const checkRepeatCustomerOrderId = (params) => post(`/vip/order/checkRepeatCustomerOrderId`, params)

// 订单来源
export const queryCustomerOrderSource = (params) => get(`/vip/orderSource/order`, params)
// 同步shopify信息
export const shopifyOrderSync = (params) => get(`/vip/shopify/order/sync`, params)
// shopify 仓库地址
export const shopifyAddressList = (params) => get(`/vip/shopify/address/list`, params)
// shopify 批量修改地址
export const shopifyOrderAddrUpdate = (params) => post(`/vip/shopify/order/orderAddrUpdate`, params)
// shopify store list
export const shopifyMyStore = (params) => get(`/vip/shopify/myStore`, params)

// 匹配客户手动输入的地址
export const queryAddressAnalysisAddress = (params) => get(`/vip/address/analysisAddress`, params)

// 获取回单金额
export const getReceiptFee = (params) => get(`/vip/order/getReceiptFeeByCode`, params)

// 下载中心列表
export const downloadCenterList = (params) => post(`/vip/exportRecord/page`, params)
// 下载中心列表删除
export const downloadCenterReqDel = (reqData) => post(`/vip/exportRecord/delete`, reqData)

// 获取币别
export const getsysCurrencyType = (params) => get(`/vip/sysCurrencyType/list`, params)

// 更新下载状态
export const updateFinishDownLoad = (params) => post(`/vip/exportRecord/updateFinishDownLoad`, params)

// 获取订单量地区前十
export const getOrderCountTopTen = (params) => post(`/vip/orderBoard/getOrderCountTopTen`, params)

// 获取走势图的接口
export const getOrderTrendChartList = (params) => post(`/vip/orderBoard/getOrderTrendChartList`, params)

// 统计运单/订单状态数据
export const getCountByStatus = (params) => post(`/vip/orderBoard/countByStatus`, params)
// 修改手机号
export const updateReceiverMobilePhone = params => post('/vip/waybillOrder/updateReceiverPhone', params)

// 修改cod金额
export const modifyCod = params => post('/vip/waybillOrder/modifyCod', params)

// 日志列表
export const logList = params => post('/vip/waybillOrder/logList  ', params)

// 查询审核状态
export const waybillLogByCode = (params) => get(`/vip/waybillOrder/waybillLogByCode`, params)
// 公告管理列表
export const noticeList = (params) => post(`vip/notice/page`, params)

// 公告管理 未读已读条数
export const noticeStatus = (params) => post(`vip/notice/queryGroupCount`, params)

// 公告管理已阅读
export const noticeReaded = (params) => post(`vip/notice/readed`, params)

// 公告管理未读公告汇总 包含强制打开列表
export const noticeUnRead = (params) => post(`vip/notice/queryUnRead`, params)

// 公告管理 详情
export const noticeDetail = (params) => post(`vip/notice/detail`, params)

// 问题件-问题件详情列表
export const problemDesc = params => post('/vip/problem/desc', params)

// 问题件-文件详情导出
export const asyExportDesc = params => post('/vip/problem/asyExportDesc', params)

// 运单分组统计接口
export const waybillCountByStatus = params => post('/vip/waybillOrder/waybillCountByStatus', params)

// 获取运单量地区前十接口
export const waybillCountTopTen = params => post('/vip/waybillOrder/getWaybillCountTopTen', params)

// 获取运单量走势接口
export const waybillTrendChartList = params => post('/vip/waybillOrder/getWaybillTrendChartList', params)
// 问题件详情
export const listVIPReplyInfos = params => post('/vip/problem/listVIPReplyInfos', params)

// 问题件回复
export const addVIPReply = params => post('/vip/problem/addVIPReply', params)

// 退件审核列表
export const problemExpressPage = params => post('/vip/reback/problemExpressPage', params)

// 退件审核详情
export const findDetail = params => get('/vip/reback/findDetail', params)

// 退件审核驳回
export const expressReject = params => post('/vip/reback/reject', params)

// 退件审核确认
export const expressAudit = params => post('/vip/reback/audit', params)

// 获取产品类型
export const availableProductlist = () => get(`/vip/baseData/availableProductlist`)

// 预取号下载
export const prefetchNumberOrder = params => post('/vip/prefetchNumberOrder/download', params)

// 客户订单号验重
export const prefetchNumberBatchSave = (params) => post(`/vip/prefetchNumberOrder/batchSave`, params)

// 回单
export const receiptOrder = params => post('/vip/order/receiptSave', params)

// 订单查询产品类型
export const getExpressType = params => get('/vip/order/getExpressType', params)

// 三方运单下单
export const threewayBatchSave = params => post('/vip/thirdWaybill/batchSave', params)
// 物料申购列表
export const materialGrantPage = params => post('/vip/material/grantPage', params)
// 物料列表
export const getMaterialPage = params => get('/vip/material/getMaterialPage', params)
// 物料申购
export const materialGrantAdd = params => post('/vip/material/grantAdd', params)
// 物料申购付款方式
export const granPayType = params => post('/vip/material/granPayType', params)
// 更新物料申购数量
export const changeNum = params => post('/vip/material/changeNum', params)
